import { render, staticRenderFns } from "./addBSQR.vue?vue&type=template&id=7aebf9d6&"
import script from "./addBSQR.vue?vue&type=script&lang=js&"
export * from "./addBSQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports